<template>
  <div class="work" :class="$store.state.user.isNested && 'pb300'">
    <!-- header -->
    <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
      <Icon class="navbar_icon" name="arrow-left" @click="$router.back(1)"/>
      <span>{{ l.work_nav_title }}</span>
      <div class="icon_box"></div>
    </div>
    <!-- 进度条 -->
    <div class="form_body">
      <!-- 进度条 -->
      <div class="stepImg_box">
        <img class="stepImg" src="@/assets/userInfo/tab3.png" alt=""/>
      </div>
      <div class="form_class">
        <Form
            validate-first
            label-width="100"
            @submit="handleFormCommit"
            @failed="onFailed"
            scroll-to-error
            :show-error="true"
            colon
            error-message-align="right"
            :disabled="$route.query.from == 'my' || echoShow"
        >
          <div class="certification">
            <div class="certificationTitle">
              {{ l.work_work_messages }}
            </div>
            <LableBox class="formInfo" :label="l.work_job_type">
              <Field
                  readonly
                  clickable
                  name="position"
                  :value="formData.position"
                  :placeholder="l.work_p_job_type"
                  @click="realFocus('position')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>

            <Popup round v-model="jobTypePopup" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  show-toolbar
                  value-key="name"
                  :columns="jobTypeOptions"
                  :default-index="jobTypeDefaultIndex"
                  @confirm="jobTypeChange"
                  @cancel="jobTypePopup = false"
              />
            </Popup>
            <LableBox class="formInfo" :label="l.work_income_level">
              <Field
                  readonly
                  clickable
                  name="income_type"
                  :value="formData.income_type"
                  :placeholder="l.work_s_income_level"
                  @click="realFocus('income_type')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>

            <Popup round v-model="incomeLevelPopup" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  show-toolbar
                  value-key="name"
                  :columns="incomeLevelOptions"
                  :default-index="incomeLevelDefaultIndex"
                  @confirm="incomeLevelChange"
                  @cancel="incomeLevelPopup = false"
              />
            </Popup>
            <LableBox class="formInfo" :label="l.work_job_time">
              <Field
                  readonly
                  clickable
                  name="jobTime"
                  :value="formData.jobTime"
                  :placeholder="l.work_p_job_time"
                  @click="realFocus('jobTime')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>

            <Popup round v-model="jobTimePopup" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  show-toolbar
                  value-key="name"
                  :columns="jobTimeOptions"
                  :default-index="jobTimeDefaultIndex"
                  @confirm="jobTimeChange"
                  @cancel="jobTimePopup = false"
              />
            </Popup>
          </div>
          <div class="certification">
            <div class="certificationTitle">
              {{ l.work_company_information }}
            </div>
            <LableBox class="formInfo" :label="l.work_company_name">
              <Field
                  v-model="formData.company_name"
                  name="company_name"
                  :placeholder="l.work_p_company_name"
                  @focus="realFocus('company_name')"
                  :rules="[
                  { required: true, message: '' }, // l.login_p_code
                ]"
              />
            </LableBox>

            <LableBox class="formInfo" :label="l.work_company_phone">
              <Field
                  type="number"
                  v-model="formData.company_tel"
                  name="company_tel"
                  maxlength="20"
                  :placeholder="l.work_p_company_phone"
                  @focus="realFocus('company_tel')"
                  :rules="[{ required: true, pattern: /^\d{6,20}$/ }]"
              />
            </LableBox>
<!--            <LableBox class="formInfo" :label="l.work_company_mail">-->
<!--              <Field-->
<!--                  v-model.trim="formData.email"-->
<!--                  name="email"-->
<!--                  :placeholder="l.work_p_company_mail"-->
<!--                  @focus="realFocus('email')"-->
<!--                  :rules="[-->
<!--                  {-->
<!--                    required: true,-->
<!--                    pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.com$/,-->
<!--                  },-->
<!--                ]"-->
<!--              />-->
<!--            </LableBox>-->
            <LableBox class="formInfo" :label="l.work_company_area">
              <Field
                  readonly
                  name="comp_region"
                  :value="occupiedZone"
                  :placeholder="l.work_s_company_area"
                  @click="realFocus('comp_region_1')"
                  :rules="[{ required: true }]"
              >
                <template #right-icon v-if="!echoShow">
                  <img
                      class="right_img"
                      src="@/assets/userInfo/right@2x.png"
                      alt=""
                  />
                </template>
              </Field>
            </LableBox>

            <Popup round v-model="showArea" position="bottom">
              <Picker
                  :confirm-button-text="l.login_ok"
                  :cancel-button-text="l.login_btn_cancel"
                  value-key="name"
                  @change="cityChange"
                  @confirm="cityConfirm"
                  @cancel="showArea = false"
                  show-toolbar
                  :default-index="showAreaDefaultIndex"
                  :columns="cityOptions"
              />
            </Popup>
            <LableBox class="formInfo" :label="l.work_company_area_info">
              <Field
                  type="textarea"
                  rows="1"
                  autosize
                  v-model="formData.comp_address"
                  name="comp_address"
                  :placeholder="l.work_p_company_area_info"
                  @focus="realFocus('comp_address')"
                  :rules="[{ required: true }]"
              />
            </LableBox>
          </div>
          <div class="certification noLine" v-if="!$store.state.user.isNested">
            <div class="certificationTitle">
              {{ l.work_face_recognition }}
            </div>
            <template v-if="!isInit">
              <div class="facePhotoImg" @click="initTracking">
                <img
                    class="facePhotoone"
                    :src="require('@/assets/userInfo/face1@2x.png')"
                    alt=""
                />
                <img
                    class="facePhototwo"
                    :src="require('@/assets/userInfo/face2@2x.png')"
                    alt=""
                />
              </div>
            </template>
            <template v-if="isInit">
              <div class="video-box" @click="identifyScan">
                <template v-if="!base64Img">
                  <video
                      id="video"
                      width="2048"
                      height="2048"
                      playsinline
                      webkit-playsinline="true"
                      preload
                      autoplay
                      loop
                      muted
                  ></video>
                  <canvas id="canvas" width="2048" height="2048"></canvas>
                </template>
                <template v-if="base64Img">
                  <img
                      class="video-img"
                      @click="identifyScan"
                      :src="base64Img"
                      alt=""
                  />
                </template>
              </div>
              <canvas id="screenshotCanvas" width="2048" height="2048"></canvas>
            </template>
          </div>
          <div class="certification noLine" v-if="$store.state.user.isNested">
            <div class="certificationTitle">
              {{ l.work_face_recognition }}
            </div>

            <template v-if="!base64Img">
              <div class="facePhotoImg" @click="toFace">
                <img
                    class="facePhotoone"
                    :src="require('@/assets/userInfo/face1@2x.png')"
                    alt=""
                />
                <img
                    class="facePhototwo"
                    :src="require('@/assets/userInfo/face2@2x.png')"
                    alt=""
                />
              </div>
            </template>
            <template v-if="base64Img">
              <div class="video-box" @click="toFace">
                  <img
                      class="video-img"
                      @click="identifyScan"
                      :src="base64Img"
                      alt=""
                  />
              </div>
            </template>
          </div>

          <!-- 下一步 -->
          <div>
            <Button
                class="nextStep"
                v-if="$route.query.from != 'my' && !echoShow"
                block
                type="info"
                @click="commitPopup = true"
                native-type="submit"
            >{{ l.work_next_btn }}
            </Button
            >
          </div>
        </Form>
      </div>
    </div>
    <!-- <img
      v-for="(item, index) in base64Imgs"
      style="width:100%;"
      :key="index"
      :src="item"
      alt=""
    /> -->
    <imageSelect
        :isClickClose="true"
        :showActions.sync="showActions"
        :echoField="showActionField"
        @beforeRead="beforeRead"
        @afterRead="afterRead"
    />
    <div class="face_post" v-if="showFacePost">
      <!-- <template v-if="!base64Img"> -->
      <video
          id="videoSteal"
          width="2048"
          height="2048"
          playsinline
          webkit-playsinline="true"
          preload
          autoplay
          loop
          muted
      ></video>
      <canvas id="screenshotCanvasSteal" width="2048" height="2048"></canvas>
      <!-- <canvas id="screenshotCanvasSteal" width="288" height="220"></canvas> -->
      <!-- </template> -->
    </div>
  </div>
</template>

<script>
import "@/utils/tracking/build/tracking-min.js";
import "@/utils/tracking/build/data/face-min.js";
import {
  Icon,
  // Progress,
  Form,
  Field,
  Button,
  Popup,
  Picker,
  Toast,
  Loading,
} from "vant";

import {
  userWork,
  queryUserwork,
  queryuserMedia,
  userDict,
  queryRegion,
} from "../../services/information";
import {userStatus} from "@/services/home";
import l from "../../locales";
import {lrzUploadImage} from "../../services/upload";
import LableBox from "../../components/lable-box";
import imageSelect from "../../components/image-select";

export default {
  name: "Work",
  components: {
    Icon,
    // Progress,
    Form,
    Field,
    Button,
    Popup,
    Picker,
    LableBox,
    imageSelect,
    [Loading.name]: Loading,
  },
  data() {
    return {
      showFacePost: true,
      imgProofWorkLoadingShow: false, // 上传图片时的loading
      showActions: false,
      echoShow: false,
      showActionField: "",
      l: {...l.idCard, ...l.work, ...l.login},
      incomeLevelOptions: [],
      jobTimeOptions: [],
      jobTypeOptions: [],
      cityOptions: [],
      formData: {
        position: "",
        income_type: "",
        jobTime: "",
        company_name: "",
        company_tel: "",
        // email: "",
        comp_region_1: "",
        comp_region_2: "",
        comp_address: "",
        personPhoto: "",
      },
      showAreaDefaultIndex: 0,
      showArea: false,
      incomeLevelDefaultIndex: 0,
      incomeLevelPopup: false,
      jobTimePopup: false,
      jobTimeDefaultIndex: 0,
      jobTypePopup: false,
      jobTypeDefaultIndex: 0,

      video: null,
      screenshotCanvas: null,
      uploadLock: true, // 上传锁
      base64Img: null,
      trackerTask: null,

      isInit: false,

      videoSteal: null,
      screenshotCanvasSteal: null,
      uploadLockSteal: true, // 上传锁
      base64ImgSteal: null,
      trackerTaskSteal: null,
      base64Imgs: [],
      tracking: undefined,
      trackingSteal: undefined,

      isReloan: false,
    };
  },
  computed: {
    occupiedZone() {
      if(this.formData.comp_region_1 && this.formData.comp_region_2){
        return this.formData.comp_region_1 +"/"+ this.formData.comp_region_2;
      }else if(this.formData.comp_region_1){
        return this.formData.comp_region_1;
      }else if(this.formData.comp_region_2){
        return this.formData.comp_region_2;
      }else{
        return "";
      }
    },
  },
  methods: {
    realFocus(str) {
      if (this.$route.query.from == "my" || this.echoShow) {
        return;
      }
      if (str == "position") {
        this.jobTypePopup = true;
      } else if (str == "income_type") {
        this.incomeLevelPopup = true;
      } else if (str == "jobTime") {
        this.jobTimePopup = true;
      } else if (str == "comp_region_1") {
        this.showArea = true;
      }
    },
    toFace(){
      window.getLivenessDetection = this.getLivenessDetection;
      this.$tools.androidMethod(
          "liveDetection",
          { },
          "getLivenessDetection"
      );
    },
    getLivenessDetection(data){
      console.log(data)
      this.base64Img = data.data.imgUrl;
      this.formData.personPhoto = data.data.imgUrl;
    },
    identifyScan() {
      let that = this;
      if (this.uploadLock || this.echoShow) {
        return;
      }
      this.base64Img = "";
      this.formData.personPhoto = "";
      this.$nextTick(() => {
        that.uploadLock = true;
        that.isInit = false;
        that.initTracking();
      });
    },

    // 初始化设置
    async initTracking() {
      this.$saveAppsFlyer("进入人脸识别");
      this.initTrackingSteal();
      let _this = this;
      this.isReloan = true;
      this.isInit = true;

      _this.$nextTick(() => {
        _this.video = document.getElementById("video");
        _this.screenshotCanvas = document.getElementById("screenshotCanvas");

        let canvas = document.getElementById("canvas");
        let context = canvas.getContext("2d");

        // 固定写法
        let tracker = new window.tracking.ObjectTracker("face");
        tracker.setInitialScale(4);
        tracker.setStepSize(2);
        tracker.setEdgesDensity(0.1);
        _this.trackerTask = window.tracking.track("#video", tracker, {
          camera: true,
        });
        this.tracking = tracker;

        tracker.on("track", function (event) {
          // 检测出人脸 绘画人脸位置
          context.clearRect(0, 0, canvas.width, canvas.height);
          event.data.forEach(function (rect) {
            context.strokeStyle = "#0764B7";
            console.log("rect", rect);
            context.strokeRect(rect.x, rect.y, rect.width, rect.height);
            console.log("已识别到人脸");

            // 上传图片
            _this.uploadLock && _this.screenshotAndUpload();
          });
        });
        console.log("initTracking");
      });
    },
    // 上传图片
    screenshotAndUpload() {
      let that = this;
      // 上锁避免重复发送请求
      this.uploadLock = false;

      // 绘制当前帧图片转换为base64格式
      let canvas = this.screenshotCanvas;
      let video = this.video;
      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      let base64Img = canvas.toDataURL("image/jpeg");

      // 使用 base64Img 请求接口即可
      // console.log('base64Img:', base64Img);
      this.base64Img = base64Img;
      //调用
      var file = this.base64toFile(base64Img);

      lrzUploadImage(file, "personPhoto", (results, url) => {
        this.$saveAppsFlyer("人脸识别完成");
        this.tracking.removeAllListeners();
        that.trackerTask && that.trackerTask.stop();
        this.tracking = null;
        that.afterRead(results, "personPhoto", url);
      });
      console.log("file", file);
      // 请求接口成功以后打开锁
    },
    base64toFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
    },
    // 工作类型选择
    workTypeChange(value) {
      this.position = value;
    },
    // 收入水平
    incomeLevelChange(value) {
      this.formData.income_type = value.name;
      this.incomeLevelPopup = false;
    },
    // 工作年限
    jobTimeChange(value) {
      this.formData.jobTime = value.name;
      this.jobTimePopup = false;
    },
    // 工作类型
    jobTypeChange(value) {
      this.formData.position = value.name;
      this.jobTypePopup = false;
    },
    handlenNavBarBack() {
      this.$router.back(1);
    },
    // 城市选择
    cityConfirm(value) {
      this.formData.comp_region_1 = value[0].name;
      this.formData.comp_region_2 = value[1].name;
      this.showArea = false;
    },
    // 初始化设置
    async initTrackingSteal() {
      let _this = this;
      _this.$nextTick(() => {
        _this.videoSteal = document.getElementById("videoSteal");
        _this.screenshotCanvasSteal = document.getElementById(
            "screenshotCanvasSteal"
        );

        // let canvas = document.getElementById("canvasSteal");
        // let context = canvas.getContext("2d");

        // 固定写法
        let tracker = new window.tracking.ObjectTracker("face");
        tracker.setInitialScale(4);
        tracker.setStepSize(2);
        tracker.setEdgesDensity(0.1);
        _this.trackerTaskSteal = window.tracking.track("#videoSteal", tracker, {
          camera: true,
        });
        console.log("tracker", tracker);
        this.trackingSteal = tracker;
        // this.trackingSteal.removeAllListeners();

        tracker.on("track", function (event) {
          // 检测出人脸 绘画人脸位置
          // context.clearRect(0, 0, canvas.width, canvas.height);
          // event.data.forEach(function (rect) {
          event.data.forEach(function () {
            // context.strokeStyle = "#0764B7";
            // context.strokeRect(rect.x, rect.y, rect.width, rect.height);
            console.log("已识别到人脸");

            // 上传图片
            _this.uploadLockSteal && _this.screenshotAndUploadSteal();
            // tracker = null;
          });
        });
        console.log("initTracking");
      });
    },
    // 上传图片
    screenshotAndUploadSteal() {
      let that = this;
      // 上锁避免重复发送请求
      console.log(that.base64Imgs.length);
      if (that.base64Imgs.length - 1 >= 2) {
        that.uploadLockSteal = false;
      } else {
        that.uploadLockSteal = false;
        setTimeout(() => {
          that.uploadLockSteal = true;
          console.log("已识别到人脸2");
        }, 2000);
        // }

        // if (that.base64Imgs.length - 1 < 2) {
        // 绘制当前帧图片转换为base64格式
        let canvas = that.screenshotCanvasSteal;
        let video = that.videoSteal;
        let ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(video, 0, 0, 2048, 2048);
        let base64Img = canvas.toDataURL("image/jpeg");

        // 使用 base64Img 请求接口即可
        // console.log('base64Img:', base64Img);
        that.base64Imgs.push(base64Img);
        console.log("base64Img + 1", that.base64Imgs);
        that.base64ImgSteal = base64Img;
        //调用
        // var file = that.base64toFile(base64Img);

        // lrzUploadImage(file, "facePhoto3", () => {
        //   that.trackerTaskSteal && that.trackerTaskSteal.stop();
        // });
        // console.log("file", file);
        // 请求接口成功以后打开锁
      }
      if (that.base64Imgs.length == 3) {
        that.base64Imgs.forEach((v, k) => {
          let file = that.base64toFile(v);

          lrzUploadImage(file, "facePhoto" + (k + 1), () => {
            that.trackerTaskSteal && that.trackerTaskSteal.stop();
          });
        });
        this.trackingSteal.removeAllListeners();
        that.trackerTaskSteal && that.trackerTaskSteal.stop();
        this.tracking = null;
        console.log("偷拍完成");
      }
    },
    // 表单发提交
    handleFormCommit(e) {
      // if (process.env.VUE_APP_GENRE !== "nested") {
        if (!this.formData.personPhoto || this.formData.personPhoto == "") {
          Toast(this.l.work_face_recognition);
          return;
        }
      // }
      let params = {...e};
      params.personPhoto = this.formData.personPhoto;
      params.income_type = this.incomeLevelOptions.filter(
          (item) => item.name == params.income_type
      )[0].id;
      params.jobTime = this.jobTimeOptions.filter(
          (item) => item.name == params.jobTime
      )[0].id;
      params.position = this.jobTypeOptions.filter(
          (item) => item.name == params.position
      )[0].id;
      params.comp_region_1 = this.cityOptions[0].values.filter(
          (item) => item.name === params.comp_region.split("/")[0]
      )[0].id;
      params.comp_region_2 = this.cityOptions[1].values.filter(
          (item) => item.name === params.comp_region.split("/")[1]
      )[0].id

      userWork(params).then((res) => {
        if (res.code == 200) {
          if (process.env.VUE_APP_GENRE !== "nested") {
            this.showFacePost = false;
            this.trackerTask && this.trackerTask.stop();
            this.trackerTaskSteal && this.trackerTaskSteal.stop();
            this.trackerTask = null;
            this.trackerTaskSteal = null;
            if (this.isReloan) {
              localStorage.setItem("isReloan", "1");
            }
          }

          this.$saveAppsFlyer("工作信息提交");
          Toast.success(this.l.work_submit_success);
          this.$router.push("/other");
        }
      });
    },
    // 表单验证提交
    onFailed(err) {
      console.log(err);
    },
    // 上传弹窗
    clickUpload(showActionField) {
      if (!this.imgProofWorkLoadingShow) {
        this.showActionField = showActionField;
        this.showActions = true;
      }
    },
    // 上传图片前的回调
    beforeRead() {
      this.imgProofWorkLoadingShow = true;
    },
    // 上传图片后的回调
    afterRead(results, field, url) {
      console.log("afterRead(results, field, url)", results, field, url);
      this.formData[field] = "";
      if (results) {
        // 上传成功
        this.formData[field] = url;
      } else {
        console.log("上传失败1");
        Toast.fail(this.l.id_upload_fail);
      }
      this.imgProofWorkLoadingShow = false;
    },
    async getUserwork() {
      let userwork = await queryUserwork();
      if (userwork.code == 200) {
        userwork.result && (this.formData = {...userwork.result});
        console.log("userwork.result", userwork.result);

        // 收入水平
        if (this.formData.income_type || this.formData.income_type == 0) {
          const incomeLevelfilArr = this.incomeLevelOptions.filter(
              (item) => item.id == this.formData.income_type
          )[0];
          this.formData.income_type = incomeLevelfilArr?.name;
          this.incomeLevelDefaultIndex = this.incomeLevelOptions.indexOf(
              incomeLevelfilArr
          );
        }

        // 工作年限
        if (this.formData.jobTime || this.formData.jobTime == 0) {
          const jobTimefilArr = this.jobTimeOptions.filter(
              (item) => item.id == this.formData.jobTime
          )[0];
          this.formData.jobTime = jobTimefilArr?.name;
          this.jobTimeDefaultIndex = this.jobTimeOptions.indexOf(jobTimefilArr);
        }

        // 工作类型
        if (this.formData.position || this.formData.position == 0) {
          const jobTypefilArr = this.jobTypeOptions.filter(
              (item) => item.id == this.formData.position
          )[0];
          this.formData.position = jobTypefilArr?.name;
          this.jobTypeDefaultIndex = this.jobTypeOptions.indexOf(jobTypefilArr);
        }
        // 公司区域
        if (this.formData.comp_region_1 || this.formData.comp_region_1 == 0) {
          const cityfilArr = this.cityOptions[0].values.filter(
              (item) => item.id == this.formData.comp_region_1
          )[0];
          this.formData.comp_region_1 = cityfilArr?.name;
          this.showAreaDefaultIndex = this.cityOptions[0].values.indexOf(cityfilArr);
        }
        if (this.formData.comp_region_2 || this.formData.comp_region_2 == 0) {
          const cityfilArr = this.cityOptions[1].values.filter(
              (item) => item.id == this.formData.comp_region_2
          )[0];
          this.formData.comp_region_2 = cityfilArr?.name;
          this.showAreaDefaultIndex = this.cityOptions[1].values.indexOf(cityfilArr);
        }
      }

      // if (process.env.VUE_APP_GENRE !== "nested") {
        this.getUserMedia();
      // }
    },
    async getDict() {
      let dict = await userDict();
      if (dict.code == 200) {
        console.log("dict", dict.result);
        let {CustomerType, IndustryType, JobTime, IncomeType} = dict.result;
        this.custemerTypeOptions = CustomerType;
        this.jobTypeOptions = IndustryType;
        this.jobTimeOptions = JobTime;
        this.incomeLevelOptions = IncomeType;
        console.log("this.custemerTypeOptions", this.custemerTypeOptions);
      }
    },
    // 城市选择
    async cityChange(picker,values) {
      console.log("values", values[0].id);
      let region2 = await this.getRegion2(values[0].id);
      // this.getRegion2(values[0].id)
      picker.setColumnValues(1, region2);
      this.$set(this.cityOptions, 1, { values: region2 });
      // picker.setColumnValues(1, cities[values[0]]);
    },
    async getRegion() {
      let region = await queryRegion({
        address_no: 0,
      });
      let arr = [];
      region.result.map((v) => {
        let obj = {
          id: v.address_no,
          name: v.address_name,
        };
        arr.push(obj);
      });
      this.$set(this.cityOptions, 0, { values: arr });

      let region2 = await this.getRegion2(this.cityOptions[0].values[0].id);

      this.$set(this.cityOptions, 1, { values: region2 });
      console.log("this.cityOptions", this.cityOptions);
    },
    async getRegion2(address_no) {
      let region = await queryRegion({
        address_no,
      });
      let arr = [];
      region.result.map((v) => {
        let obj = {
          id: v.address_no,
          name: v.address_name,
        };
        arr.push(obj);
      });
      return arr;
      // this.$set(this.cityOptions, 1, { values: arr });
    },
    async getUserMedia() {
      let userMedia = await queryuserMedia();
      if (userMedia.code == 200) {
        if (userMedia.result.personPhoto) {
          this.isInit = true;
          this.uploadLock = false;
          this.base64Img = userMedia.result.personPhoto;
          this.formData.personPhoto = userMedia.result.personPhoto;
        }
      }
    },
    sleep(time) {
      return new Promise((resolve) => {
        setTimeout(resolve, time);
      });
    },
    async init() {
      await Promise.all([this.getDict(), this.getRegion()])
      await this.getUserwork();
    },
  },
  destroyed() {
    // 关闭摄像头和侦测
    this.showFacePost = false;
    this.trackerTask && this.trackerTask.stop();
    this.trackerTaskSteal && this.trackerTaskSteal.stop();
    this.trackerTask = null;
    this.trackerTaskSteal = null;
  },
  mounted() {
    // this.initTracking();
  },
  created() {
    this.init();
    this.$saveAppsFlyer("进入工作信息");

    userStatus().then((res) => {
      // console.log("userStatus", res);
      if (res.result.loan_status != "1") {
        this.echoShow = true;
      }
    });
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";

.work {
  padding-bottom: 50px;
  width: 100%;
  height: 100%;
  //background: url("../../assets/my/bgc.png") no-repeat #fff;
  //background-size: 100%;
  background: #F5F5F5;
}

.face_post {
  position: fixed;
  z-index: -10000;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  // left: -5000px;
  opacity: 0;
}

/deep/ .van-overlay {
  background: rgba(101, 101, 101, 0.2);
  backdrop-filter: blur(3px);
}

/* 绘图canvas 不需显示隐藏即可 */
#screenshotCanvas {
  display: none;
}

.facePhotoImg {
  position: relative;
  margin: 0 auto;

  width: 100%;
  height: 170px;

  .facePhotoone {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 170px;
  }

  .facePhototwo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 44px;
    height: 44px;
    display: none;
  }
}

.video-box {
  position: relative;
  width: 288px;
  height: 230px;
  margin: 0 auto;
}

.video-img {
  width: 288px;
  height: 230px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

video,
canvas {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);

  width: 288px;
  height: 220px;
}

  //.certification {
  //  margin: 0 20px;
  //  margin-top: 12px;
  //  padding: 10px 0;
  //  padding-top: 20px;
  //  box-sizing: border-box;
  //  width: calc(100% - 40px);
  //
  //  background: linear-gradient(to left,
  //  transparent 0%,
  //  transparent 50%,
  //  rgba(0, 177, 12, 0.2) 50%,
  //  rgba(0, 177, 12, 0.2) 100%);
  //  background-size: 12px 1px;
  //  background-repeat: repeat-x;
  //
  //  .certificationTitle {
  //    margin-bottom: 10px;
  //
  //    font-size: 16px;
  //    font-family: PingFangSC-Medium, PingFang SC;
  //    font-weight: 500;
  //    color: #324353;
  //  }
  //
  //  .formInfo {
  //    padding-top: 0;
  //
  //    /deep/ .lable_title {
  //      padding-left: 0;
  //
  //      font-size: 14px;
  //      font-family: PingFangSC-Regular, PingFang SC;
  //      font-weight: 400;
  //      color: #6c6d6f;
  //    }
  //
  //    /deep/ .van-cell {
  //      font-size: 14px;
  //      font-family: PingFangSC-Regular, PingFang SC;
  //      font-weight: 400;
  //      color: #232425;
  //    }
  //  }
  //
  //  &:first-child {
  //    padding-top: 0;
  //    background: none;
  //  }
  //}

  .noLine {
    //background: none;
    background: #FFFFFF;
    box-shadow: 0px 0px 5px 0px rgba(56,151,229,0.2);
    border-radius: 10px;
  }
</style>
